import { CommitmentSourcesTestService } from '@festina/life-general-types/life-test/services/CommitmentSourcesTestService'
import { useFestinaMutation } from '@festina-life/authentication'

type Props = {
  tenantId: string
  ownerId: string
}

const method = CommitmentSourcesTestService.commitmentSourcesTestServicePostTime

type TriggerProps = NonNullable<Parameters<typeof method>[0]['requestBody']>

export const useSubmitCommitmentTime = ({ ownerId, tenantId }: Props) =>
  useFestinaMutation({
    component: 'life',
    roles:
      CommitmentSourcesTestService.commitmentSourcesTestServicePostTime_roles,
    isScenario: false,
    mutateFunction: async (arg: TriggerProps) => {
      await method({
        xTenantId: tenantId,
        ownerId,
        requestBody: arg,
      })
    },
  })
